import defaultMetaOverrideSet from './metaOverrides/default';
import fqTmplInsightOverrideSet from './metaOverrides/FQTmplInsightOverrideSet';
import fqTmplQuestionOverrideSet from './metaOverrides/FQTmplQuestionOverrideSet';

const metaOverrideMap = {
  FQTmplInsight: fqTmplInsightOverrideSet,
  FQTmplQuestion: fqTmplQuestionOverrideSet,
};

export const getMetaOverrideSet = (resourceType) => {
  let metaOverride = metaOverrideMap[resourceType];
  if (!metaOverride) {
    metaOverride = defaultMetaOverrideSet;
  }
  return metaOverride;
};
